import * as S from './RetainerSection.styled';

type Props = {
    title: string;
    children?: React.ReactNode;
    style?: React.CSSProperties;
};

export default function RetainerSection(args: Props) {
    return (
        <S.Section style={args.style}>
            <S.Title>{args.title}</S.Title>
            {args?.children}
        </S.Section>
    );
}
